import React from 'react';
import {connect} from "react-redux";
import SingleChoiceViewMode from "./SingleChoiceViewMode";
import MultipleChoiceViewMode from "./MultipleChoiceViewMode";
import MatrixViewMode from './MatrixViewMode';
import TextViewMode from "./TextViewMode";
import JumbotronViewMode from "./JumbotronViewMode";
import NumberViewMode from "./NumberViewMode";
import MultipleOpenViewMode from "./MultipleOpenViewMode";

function QuestionViewMode(props) {
    switch(props.questionData.type) {
        case "singleChoice":
            return (<SingleChoiceViewMode questionData={props.questionData}/>);
        case "multipleChoice":
            return (<MultipleChoiceViewMode questionData={props.questionData}/>);
        case "text":
            return (<TextViewMode/>);
        case "selects":
            return (<MatrixViewMode questionData={props.questionData}/>);
        case "jumbotron":
            return (<JumbotronViewMode questionData={props.questionData}/>);
        case "multipleOpen":
            return (<MultipleOpenViewMode questionData={props.questionData}/>);
        case "number":
            return (<NumberViewMode questionData={props.questionData}/>);
        case "rating":
            return null;
        default:
            return null;
    }
}

function mapStateToProps(state) {
    return {};
}

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(QuestionViewMode);